var React = require('react');

function CloudInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M835.765 204.486C835.935 232.136 830.643 258.545 820.901 282.691C876.84 287.686 929.529 312.148 969.559 352.178C1014.66 397.281 1040 458.453 1040 522.237H799.5H637L559 522.237L318.5 522.237H0C-3.65654e-06 480.411 8.23824 438.995 24.2444 400.353C40.2505 361.71 63.711 326.599 93.2865 297.024C122.862 267.448 157.973 243.988 196.615 227.982C235.258 211.976 276.674 203.737 318.5 203.737C354.789 203.737 390.771 209.939 424.899 222.035C424.511 217.077 424.298 212.07 424.267 207.02C423.567 93.3876 515.117 0.703532 628.749 0.00398248C742.381 -0.695567 835.065 90.8543 835.765 204.486Z","fill":"#F9FAFA"}));
}

CloudInline.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 1040 523","fill":"none"};

module.exports = CloudInline;

CloudInline.default = CloudInline;
